import React from 'react';

import { Typography } from 'antd';

import './MarketingPreviewArea.less';

import { AssetPreview } from 'pages/asset-full-view/components';

import * as productServices from 'services/product';

const { Title } = Typography;

const MarketingPreviewArea = (props) => {
  const { imageInfo, productInfo } = props;

  const mapImageInfoToAssetData = (_imageInfo) => {
    return {
      ..._imageInfo,
      fileUrl: _imageInfo?.originalFile,
      metadata: { fileType: _imageInfo?.fileType },
      thumbnail:
        _imageInfo?.thumbFull ||
        _imageInfo?.thumb1000 ||
        _imageInfo?.thumb500 ||
        _imageInfo?.thumb300,
      isOwner: productInfo?.isOwner,
    };
  };

  const reloadDownloadAssetData = async (cachedDownloadUrlRef) => {
    try {
      const response = await productServices.getMarketingAssets({
        productId: productInfo?.productId,
        isShowAll: true,
      });

      const { isSuccess, data } = response;

      if (!isSuccess) return assetData;

      const imageList = data?.gridData;

      if (!imageList?.length) return assetData;

      const imageData = imageList.find((image) => {
        return image?.id === imageInfo?.id;
      });
      //* store new download asset to keep download asset work correctly when change asset selection
      cachedDownloadUrlRef.current = {
        ...cachedDownloadUrlRef.current,
        [assetData?.digitalAssetId]: imageData.originalFile,
      };

      return mapImageInfoToAssetData(imageData) || assetData;
    } catch (error) {
      return assetData;
    }
  };

  const assetData = mapImageInfoToAssetData(imageInfo);

  return (
    <div className='image-preview-area'>
      <div className='image-preview-area__image-wrapper'>
        {imageInfo ? (
          <AssetPreview
            assetData={assetData}
            reloadDownloadAssetData={reloadDownloadAssetData}
          />
        ) : (
          <Title level={2} className='image-preview-area__no-preview-message'>
            No Image
          </Title>
        )}
      </div>
    </div>
  );
};

export default MarketingPreviewArea;
